import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import React, { useCallback } from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import SearchIcon16 from '@wix/da-ds/pkg/Icons/16x16/Search';
import SearchModal from '../../../_partials/SearchModal';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
const SearchIconButton = ({ className, isSearchModalShown, openSearchModal, closeSearchModal })=>{
    const handleOpen = useCallback(()=>{
        yieldToMain(()=>{
            openSearchModal();
        });
    }, [
        openSearchModal
    ]);
    const handleClose = useCallback(()=>{
        yieldToMain(()=>{
            closeSearchModal();
        });
    }, [
        closeSearchModal
    ]);
    const isDsUpdate = useFlag('ds_update_btn_medium');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        className: className,
        size: "medium",
        icon: isDsUpdate ? SearchIcon16 : SearchIcon,
        biData: BiData({
            evid: 700,
            link_name: 'search'
        }),
        onClick: handleOpen
    }), isSearchModalShown && /*#__PURE__*/ React.createElement(SearchModal, {
        onClose: handleClose
    }));
};
SearchIconButton.displayName = 'SearchIconButton';
export default SearchIconButton;

//# sourceMappingURL=SearchIconButton.js.map